import { useTranslation } from 'react-i18next';
import { getTaskTagDisplayList } from '../../utils/taskTags';
import './TaskTagChips.css';

/**
 * Compact tag chips for tables and cards.
 * @param {object} task — production task with tagIds/tagNames
 * @param {Map} [tagsById] — live tag definitions for colors
 * @param {number} [maxVisible=2] — collapse extras behind "+N more"
 */
export default function TaskTagChips({ task, tagsById, maxVisible = 2, className = '' }) {
  const { t } = useTranslation();
  const tags = getTaskTagDisplayList(task, tagsById);
  if (!tags.length) return null;

  const visible = tags.slice(0, maxVisible);
  const hidden = tags.length - visible.length;

  return (
    <div className={`task-tag-chips ${className}`.trim()} aria-label={t('tags.taskTags')}>
      {visible.map((tag) => (
        <span
          key={tag.id}
          className={`task-tag-chip task-tag-chip--${tag.color}${tag.archived ? ' task-tag-chip--archived' : ''}`}
          title={tag.archived ? `${tag.name} (${t('tags.archived')})` : tag.name}
        >
          {tag.name}
        </span>
      ))}
      {hidden > 0 && (
        <span className="task-tag-chip-more" title={tags.slice(maxVisible).map((tg) => tg.name).join(', ')}>
          +{hidden} {t('tags.more')}
        </span>
      )}
    </div>
  );
}
